import { render, staticRenderFns } from "./OeGenDetail.vue?vue&type=template&id=90775fc4&scoped=true&"
import script from "./OeGenDetail.vue?vue&type=script&lang=js&"
export * from "./OeGenDetail.vue?vue&type=script&lang=js&"
import style0 from "./OeGenDetail.vue?vue&type=style&index=0&id=90775fc4&prod&scoped=true&lang=css&"
import style1 from "./OeGenDetail.vue?vue&type=style&index=1&id=90775fc4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90775fc4",
  null
  
)

export default component.exports